import { useState } from "react";
import Search from "../../components/form/Search";
import Table from "../../components/elements/table/Table";
import { handleFilterChange } from "../../helpers";
import { useDebounce } from "../../hooks/useDebounce";
import useFetch from "../../hooks/useFetch";
import Button from "../../components/form/Button";
import LimitSelect from "../../components/elements/LimitSelect";
import { toast } from "react-toastify";
import useMutation from "../../hooks/useMutation";
import DeleteModal from "../../components/common/DeleteModal";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { setTitle } from "../../helpers/MetaTag";
import { useGetPermission } from "../../hooks/useGetPermission";
import { contactDelete, contactList } from "../../services/contactService";
import ManageReplyModal from "../../components/sections/admin/contactUs/modals/ManageReplyModal";
import ManageChatHistoryyModal from "../../components/sections/admin/contactUs/modals/ChatHistoryModal";

function ContactUs() {
  setTitle("Vpeters Admin | ContactUs");
  const { permission, status } = useGetPermission("contactUs");
  const { session } = useSelector((state) => state?.authProvider);
  const isAdmin = session?.user?.roleCode === "admin";
  const [keyword, setKeyword] = useState("");
  const [filters, setFilters] = useState({
    limit: 10,
    page: 1,
    sortQuery: "-createdAt",
  });
  const location = useLocation();
  const pathName = location.pathname;

  const search = useDebounce(keyword, 300);
  const [replyModal, setReplyModal] = useState({
    isOpen: false,
    data: null,
  });
  const [chatHistoryModal, setChatHistoryModal] = useState({
    isOpen: false,
    data: null,
  });
  const [deleteModal, setDeleteModal] = useState({
    isOpen: false,
    data: null,
  });

  const {
    data: contactData,
    isLoading: contactLoading,
    updateData,
    refetch,
  } = useFetch({
    dependencies: ["contactList", permission?.list, filters, search],
    fetchFunction: async () => {
      const res = await contactList({
        ...filters,
        parentId: 0,
        ...(pathName.includes("user") && { status: 1 }),
        ...(search && { keyword: search }),
      });
      if (res?.status !== 200) {
        toast.warning(res?.message || res?.error);
      }
      return res.docs;
    },
    enabled: !!permission?.list && status === "ok",
  });

  const tableHeadData = [
    {
      _id: 1,
      name: "Name",
      align: "left",
    },
    {
      _id: 2,
      name: "Email",
      align: "left",
    },
    {
      _id: 4,
      name: "Enquiry",
      align: "left",
    },
    ...(isAdmin
      ? [
          ...(permission?.delete
            ? [
                {
                  _id: 7,
                  name: "Action",
                  align: "left",
                },
              ]
            : []),
        ]
      : []),
  ];

  const tableData = [...(contactData?.data || [])]?.map((item) => {
    return {
      _id: item?._id,
      rowData: [
        {
          _id: 2,
          type: "user",
          align: "left",
          cellClass: "!min-w-[100px]",
          image: item?.image?.url,
          data: item?.name || "N/A",
        },
        {
          _id: 21,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.email || "N/A",
        },
        {
          _id: 21,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.comment || "N/A",
        },
        ...(isAdmin
          ? [
              ...(permission?.delete
                ? [
                    {
                      _id: 6,
                      type: "action",
                      align: "left",
                      cellClass: "w-[5%]",
                      actionData: [
                        {
                          _id: 1,
                          name: "Reply History",
                          icon: "fa-regular fa-comment",
                          onClick: () => {
                            setChatHistoryModal({
                              isOpen: true,
                              data: item,
                            });
                          },
                        },
                        {
                          _id: 2,
                          name: "Reply",
                          icon: "fa-regular fa-reply",
                          onClick: () => {
                            setReplyModal({
                              isOpen: true,
                              data: item,
                            });
                          },
                        },
                        ...(permission?.delete && status === "ok"
                          ? [
                              {
                                _id: 3,
                                name: "Delete",
                                icon: "fa-regular fa-trash-can",
                                standout: true,
                                onClick: () => {
                                  setDeleteModal({
                                    isOpen: true,
                                    data: item,
                                  });
                                },
                              },
                            ]
                          : []),
                      ],
                    },
                  ]
                : []),
            ]
          : []),
      ],
    };
  });

  //   //   user status change handler =================>
  //   const { mutate: statusChangeHandler, isPending: statusChangeInPending } =
  //     useMutation({
  //       mutationFn: async ({ id, status }) => {
  //         const res = await resourceStatusChange({
  //           ids: id,
  //           status,
  //         });
  //         return { res, payload: { id, status } };
  //       },
  //       onSuccess: ({ res, payload }) => {
  //         if (res?.status !== 200) {
  //           updateData((pre) => {
  //             pre.data = (pre?.data || []).map((elm) =>
  //               elm?._id === payload?.id
  //                 ? { ...elm, status: payload?.status === 1 ? 2 : 1 }
  //                 : elm
  //             );
  //             return { ...pre };
  //           });
  //           toast.warning(res?.message || res?.error);
  //         }
  //       },
  //       onError: (error) => {
  //         console.log(error);
  //       },
  //     });

  // add or edit Application Form =================>
  function applicationFormManageResponse(res) {
    if (res?.status === 200 || res?.status === 201) {
      refetch();
    } else {
      toast.warning(res?.message || res?.error);
    }
  }

  //   Application Form delete handler =================>
  const { mutate: deleteHandler, isPending: deletePending } = useMutation({
    mutationFn: async (payload) => {
      const res = await contactDelete({
        ids: Array.isArray(payload) ? payload : [payload],
      });
      return { res, payload: Array.isArray(payload) ? payload : [payload] };
    },
    onSuccess: ({ res, payload }) => {
      if (res?.status === 200) {
        setDeleteModal({ isOpen: false, data: null });
        updateData((pre) => {
          pre.data = (pre?.data || [])?.filter(
            (item) => !payload?.includes(item?._id)
          );
          return { ...pre };
        });
        if (contactData?.metadata?.totalDocs > filters?.limit) {
          refetch();
        }
      } else {
        toast.warning(res?.message || res?.error);
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });

  return (
    <div>
      <h1 className="text-3xl font-bold text-[#C94E53]  px-6 py-4 rounded-2xl text-center ">
        Contact List
      </h1>
      {pathName.includes("user") && (
        <h1 className="text-base font-bold   px-3 py-2 rounded-xl  bg-white mb-2">
          Explore tools and tips for funding your education, applying for the
          V’Peters Scholarship, and planning your future—all in the Resource
          Library.
        </h1>
      )}
      <div className="flex gap-2">
        <div className="relative">
          <LimitSelect
            value={filters?.limit}
            allValue={contactData?.metadata?.totalDocs}
            onChange={(val) => handleFilterChange("limit", val, setFilters)}
          />
        </div>
        <div className="w-72 mb-2">
          <Search
            placeholder={"Search here"}
            search={(val) => {
              setKeyword(val);
              handleFilterChange("page", 1, setFilters);
            }}
          />
        </div>
      </div>
      {status === "ok" &&
        (permission?.list ? (
          <div className="mb-2">
            <Table
              tableHeadData={tableHeadData}
              tableData={tableData}
              isLoder={contactLoading}
              pageCount={contactData?.metadata?.totalPages}
              currentPage={filters?.page}
              onPageChange={(val) => {
                handleFilterChange("page", val, setFilters);
              }}
              originalData={[...(contactData?.data || [])]}
              isOrderingDisabled={true}
              tableActionDropdownContainer={"!w-48"}
              // handleOrdering={(newData, oldData) => {
              //   messageOrderingHandler(newData, oldData);
              // }}
              // setOriginalData={(data) =>
              //   updateData((pre) => {
              //     pre.data = data;
              //     return { ...pre };
              //   })
              // }
              // isFetching={isFetching}
              // selectedItems={selectedItems}
              // setSelectedItems={setSelectedItems}
            />
          </div>
        ) : (
          <div className="font-semibold text-xl text-center h-60 flex items-center justify-center text-shades-07">
            You don't have permission to view this list.
          </div>
        ))}
      <ManageReplyModal
        open={replyModal?.isOpen}
        data={replyModal?.data}
        close={() => setReplyModal({ isOpen: false, data: null })}
        getResponse={applicationFormManageResponse}
      />
      <ManageChatHistoryyModal
        open={chatHistoryModal?.isOpen}
        data={chatHistoryModal?.data}
        close={() => setChatHistoryModal({ isOpen: false, data: null })}
        getResponse={applicationFormManageResponse}
      />
      <DeleteModal
        open={deleteModal?.isOpen}
        loading={deletePending}
        onClose={() => setDeleteModal((pre) => ({ data: null, isOpen: false }))}
        deleteHandler={() => {
          deleteHandler(deleteModal?.data?._id);
        }}
      />
    </div>
  );
}

export default ContactUs;
